
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maszyny-budowlane-sprzedaz/[marka]",
      function () {
        return require("private-next-pages/maszyny-budowlane-sprzedaz/[marka]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/maszyny-budowlane-sprzedaz/[marka]"])
      });
    }
  